/* eslint-disable @typescript-eslint/naming-convention */
import { Entity } from "src/app/shared/types/entity.type";

//#region Interface
export interface ConfigurableOption extends Entity {
  id?: string;
  value?: string;
  type?: ConfigurableOptionTypes;
}

//#endregion

//#region Enum
export enum ConfigurableOptionTypes {
  Sla = "sla",
}

//#endregion
